<template>
  <PublicLayout>
    <h1 class="public__title">Professionnels</h1>
    <p class="public__lead">
      Saineo collabore avec des professionnels de santé, des marques engagées et des acteurs du bien-être.
    </p>

     <h2 class="public__section-title">Notre approche scientifique</h2>
    <ul class="public__list">
      <li>Saineo a été conçu pour replacer la science nutritionnelle au cœur de l’alimentation quotidienne.</li>
      <li>La plateforme s’appuie sur une base de recettes équilibrées développées avec des professionnels de la nutrition et sur un algorithme basé sur des règles nutritionnelles précises.</li>
      <li>Contrairement aux générateurs de recettes aléatoires ou aux recommandations issues d’IA générative, Saineo vise à proposer des plans alimentaires cohérents, fiables et adaptés aux besoins de chaque utilisateur.</li>
   <li>Saineo prend aujourd’hui en compte : endométriose, SOPK, prédiabète, allergies alimentaires, intolérances au gluten et au lactose, et maladie cœliaque.</li>
    </ul>

    <h2 class="public__section-title">Collaborer avec Saineo</h2>
    <ul class="public__list">
      Nous travaillons avec différents acteurs engagés dans la santé et la nutrition :
      <li>Professionnels de santé (nutritionnistes, diététiciens, médecins),</li>
      <li>Marques engagées dans l'alimentation saine,</li>
      <li>Acteurs du bien-être et de la prévention santé,</li>
      <li>Créateurs de recettes (blogueurs culinaires, créateurs food sur les réseaux sociaux, auteurs de recettes),</li>
      <li>Créateurs de contenu nutrition (vulgarisation scientifique, éducation nutritionnelle, prévention santé),</li>
      <li>Créateurs de contenu sport et performance (coachs sportifs, créateurs fitness, préparation physique),</li>
    </ul>
    
    <h2 class="public__section-title">Pourquoi devenir partenaire ?</h2>
    <ul class="public__list">
      <li>Contribuer à une alimentation plus saine auprès d’une communauté engagée,</li>
      <li>Participer à un projet innovant qui vise à simplifier l’alimentation quotidienne,</li>
      <li>Co-construire des solutions utiles pour des personnes ayant des besoins alimentaires spécifiques (allergies, pathologies, objectifs nutritionnels),</li>
      <li>...</li>
    </ul>
    
    <h2 class="public__section-title">Nous contacter</h2>
    <p class="public__text">Écrivez à <strong>contact@saineo.fr</strong> pour échanger.</p>
  </PublicLayout>
</template>

<script>
import PublicLayout from './PublicLayout.vue';

export default {
  name: 'PartnersPage',
  components: { PublicLayout },
};
</script>
